<template>
  <TableLayout :permissions="['business:category:query']">
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
      <el-form-item label="类别名称" prop="name">
        <el-input v-model="searchForm.name" placeholder="请输入类别名称" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <!-- <el-button type="primary" :loading="isWorking.export" v-permissions="['business:category:exportExcel']" @click="exportExcel">导出</el-button> -->
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <ul class="toolbar" v-permissions="['business:category:create']">
        <li><el-button type="primary" @click="$refs.operaCategoryWindow.open('新建类别')" icon="el-icon-plus"
            v-permissions="['business:category:create']">新建</el-button></li>
      </ul>
      <el-table v-loading="isWorking.search" :data="tableData.list" stripe border :header-cell-style="rowStyle"
        :cell-style="rowStyle">
        <el-table-column prop="imgurl" label="图标" min-width="100px">
          <template slot-scope="{row}">
            <el-image v-if="row.imgurl" style="width: 70px; height: 70px" :src="row.imgfullurl"
              :preview-src-list="[row.imgfullurl]" fit="cover"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="类别名称" min-width="100px"></el-table-column>
        <el-table-column prop="priceRate" label="加价系数" min-width="100px"></el-table-column>
        <el-table-column prop="sortnum" label="排序码(升序)" min-width="100px"></el-table-column>
        <el-table-column prop="createDate" label="创建时间" min-width="100px"></el-table-column>
        <el-table-column v-if="containPermissions(['business:category:update'])" prop="status" label="状态" min-width="100px">
          <template slot-scope="{row}">
            <el-switch v-model="row.status" @change="changeStatus(row)" :active-value="0" :inactive-value="1">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column v-if="containPermissions(['business:category:update', 'business:category:delete'])" label="操作"
          min-width="120" fixed="right">
          <template slot-scope="{row}">
            <el-button type="text" @click="edit(row.id)" v-permissions="['business:category:update']">编辑</el-button>
            <el-button type="text" @click="deleteById(row)" v-permissions="['business:category:delete']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination @size-change="handleSizeChange" @current-change="handlePageChange" :pagination="tableData.pagination">
      </pagination>
    </template>
    <!-- 新建/修改 -->
    <OperaCategoryWindow ref="operaCategoryWindow" @success="handlePageChange" />
  </TableLayout>
</template>
  
<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaCategoryWindow from '@/components/business/OperaCategoryWindow'
import { queryById, updateDisableById } from '@/api/business/category.js'
export default {
  name: 'Category',
  extends: BaseTable,
  components: { TableLayout, Pagination, OperaCategoryWindow },
  data() {
    return {
      // 搜索
      searchForm: {
        name: ''
      }
    }
  },
  created() {
    this.config({
      module: '类别',
      api: '/business/category',
      'field.id': 'id',
      'field.main': 'name'
    })
    this.search()
  },
  methods: {
    rowStyle() {
      return "text-align:center";
    },
    changeStatus(item) {
      updateDisableById({
        id: item.id,
        status: item.status
      }).then(res => {
        this.$tip.apiSuccess('更新成功')
      }).catch (err => {
          this.$message.error(err)
        })
        .finally(() => {
        this.handlePageChange()
      })
    },
    edit(id) {
      queryById(id)
        .then(res => {
          let obj = {
            id,
            name: res.name,
            attrFirst: res.attrFirst,
            attrFirstList: res.attrFirstList,
            attrSecond: res.attrSecond,
            attrSecondList: res.attrSecondList,
            sortnum: res.sortnum,
            paramList: res.paramList,
            imgurl: res.imgurl,
            budgetList: res.budgetList,
            fileList: res.imgurl ? [{ url: res.prefixUrl + res.imgurl }] : []
          }
          this.$refs.operaCategoryWindow.open('编辑类别', res)
        })
    }
  }
}
</script>
  